/**
 * Tema da aplicação (light | dark), persistido em localStorage.
 * Padrão: light.
 */

export const THEME_STORAGE_KEY = "theme";

const VALID_THEMES = ["light", "dark"];

/**
 * @returns {"light"|"dark"}
 */
export function getStoredTheme() {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    if (raw && VALID_THEMES.indexOf(raw) !== -1) {
      return raw;
    }
  } catch (e) {
    // storage indisponível
  }
  return "light";
}

/**
 * @param {"light"|"dark"} theme
 */
export function applyTheme(theme) {
  const resolved = VALID_THEMES.indexOf(theme) !== -1 ? theme : "light";
  document.documentElement.setAttribute("data-app-theme", resolved);
  if (document.body) {
    document.body.setAttribute(
      "data-sidebar",
      resolved === "dark" ? "dark" : "light"
    );
  }
}

/**
 * @param {"light"|"dark"} theme
 */
export function setTheme(theme) {
  const resolved = VALID_THEMES.indexOf(theme) !== -1 ? theme : "light";
  try {
    localStorage.setItem(THEME_STORAGE_KEY, resolved);
  } catch (e) {
    // ignora falha de escrita
  }
  applyTheme(resolved);
}

export function startTheme() {
  applyTheme(getStoredTheme());
}
